// A Hebrew message that the guest actually SEES when a result page gives up (KARNI follow-up, 2026-10-31).
//
// The result pages used to pass the reason in the navigation state ({ state: { error } }), some of it in English, and
// no Swingies/MiniMove page ever read it: at KARNI (2026-10-25) the guests whose approve was lost got the failed GIF,
// then Home, with no word. showGuestNotice() shows the message as a toast at the moment the failed screen appears and
// keeps it through the page's wait and the navigation (App.js mounts the one ToastContainer above the routes).
import { showAlert } from "../../../generalUtils";

// How long a message stays on screen after the page has moved on.
export const GUEST_NOTICE_MS = 7000;

// The lost approve could not be sent again in this visit (the event ended).
export const MSG_APPROVE_NOT_SENT = "התמונה לא נשלחה, אפשר להתחיל מחדש";
// Some chosen faces are missing on the server.
export const MSG_FACES_MISSING = "חלק מהפרצופים לא נמצאו, נא לבחור שוב";
// Any other refusal the page has no specific text for.
export const MSG_APPROVE_ERROR = "אירעה שגיאה, נא לנסות שוב";

// Shows `message` now, for the page's own wait (`waitMs`, before it navigates) plus GUEST_NOTICE_MS.
export const showGuestNotice = (message, waitMs = 0) => {
  if (message) showAlert("err", message, waitMs + GUEST_NOTICE_MS);
};
